// Local copy of packages/ui/src/lib/reportBuild.ts — this app deliberately has
// no @meno/ui dependency (see components/FrameMarkDraw.tsx). Keep in sync.

// Tell the backend which build of this app is running, so the internal admin's
// Ops pages show live per-environment versions instead of a committed registry
// that went stale on every deploy (backend: app/api/routes/client_builds.py).
//
// The stamp is the one scripts/viteVersionDefine.mjs bakes into every bundle.
// Once per tab session and per build, fire-and-forget: it never blocks boot,
// never retries, and a failure is silent (it is telemetry, not a feature).
// Skipped in local dev so developer machines don't pollute the history.

type AppKey = 'webplayer'

export function reportBuild(app: AppKey): void {
  try {
    const env = (import.meta as any).env ?? {}
    const appEnv: string = env.VITE_APP_ENV ?? ''
    if (appEnv !== 'staging' && appEnv !== 'production') return
    const version: string = env.VITE_APP_VERSION ?? ''
    const sha: string = env.VITE_GIT_SHA ?? 'unknown'
    const backend = String(env.VITE_BACKEND_URL ?? '').replace(/\/$/, '')
    if (!backend || !version) return

    const key = `wt.build-reported:${app}:${sha}:${version}`
    try {
      if (sessionStorage.getItem(key)) return
      sessionStorage.setItem(key, '1')
    } catch { /* storage blocked: report anyway, the backend dedupes */ }

    void fetch(`${backend}/api/v1/client-builds`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        app, version, git_sha: sha, env: appEnv, build_time: env.VITE_BUILD_TIME || null,
      }),
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {})
  } catch { /* never let telemetry break boot */ }
}
